import { render, staticRenderFns } from "./PxCamposCompraItemTableUseall.vue?vue&type=template&id=1cc00640&"
import script from "./PxCamposCompraItemTableUseall.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemTableUseall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports